module.exports = __webpack_public_path__ + "img/file-circle.44d501e5.svg";